import * as React from 'react'
import * as st from './bannerContainer.module.scss'

export interface BannerContainerProps {
  isRetail: boolean
}

export const BannerContainer: React.SFC<BannerContainerProps> = ({ isRetail, children } )=> {
  return (
    <div className={isRetail ? st.retailBannerContainer : st.globalBannerContainer}>
      {children}
    </div>
  )
}